import React, { Component } from 'react';
import { debounce } from 'lodash';
import { connect } from 'react-redux';
import LoggedInUser from '../../components/logged-in-user';
import Signin from '../../components/commit-form/signin';
import SigninOption from '../../components/commit-form/signin-option';
import {
  authenticateUserWithPassword,
  unauthenticateUser,
  userExists,
  showSigninFormSection,
  showSignupFormSection,
  hideSigninFormSection,
  hideSignupFormSection,
  showModalInnerAlert,
  sendMagicLink,
  SIGNIN_FORM_SECTION,
} from '../../actions';

class SigninContainer extends Component {
  constructor(props) {
    super(props);

    this.checkUserExistence = debounce(props.userExists, 500, { maxWait: 2000 });
    this.onLogout = this.onLogout.bind(this);
    this.showSigninForm = this.showSigninForm.bind(this);
    this.hideSigninForm = this.hideSigninForm.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onLogin = this.onLogin.bind(this);
  }

  onLogout() {
    this.props.unauthenticateUser()
      .then(() => this.props.onLogout());
  }

  onLogin() {
    this.props.onLogin();
  }

  onSendMagickLink = (email) => {
    const content = (
      <span>
        <strong>Check your inbox</strong> and click the link there then refresh this page.
      </span>
    );
    return this.props.sendMagicLink(email)
      .then(() => this.props.showModalInnerAlert(content, 'success'))
  }

  onSubmit(props) {
    return this.props.authenticateUserWithPassword(props.email, props.password)
      .then(this.onLogin)
      .catch(() => {
        return this.props.showModalInnerAlert('Invalid password');
      });
  }

  hideSigninForm() {
    this.props.hideSigninFormSection();
    this.props.showSignupFormSection();
    this.props.onHideSigninForm();
  }

  showingSigninForm() {
    return !this.props.user && this.props.showingSigninForm;
  }

  showSigninForm() {
    this.props.showSigninFormSection();
    this.props.hideSignupFormSection();
  }

  render() {
    if (this.props.user) {
      return <LoggedInUser onLogout={this.onLogout} user={this.props.user} />;
    }

    if (!this.showingSigninForm()) {
      return <SigninOption onSigninClick={this.showSigninForm} />;
    }

    return (
      <Signin
        method={this.props.method}
        onEmailChange={this.checkUserExistence}
        onHideClick={this.hideSigninForm}
        onSendLink={this.onSendMagickLink}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = ({ users, ui }) => {
  return {
    method: users.existence,
    user: users.byId[users.current],
    showingSigninForm: ui.formSections[SIGNIN_FORM_SECTION] === true,
  };
};

SigninContainer.defaultProps = {
  onLogin: () => {},
  onLogout: () => {},
  onHideSigninForm: () => {},
};

const mapDispatchToProps = {
  hideSigninFormSection,
  showSigninFormSection,
  showSignupFormSection,
  hideSignupFormSection,
  userExists,
  unauthenticateUser,
  authenticateUserWithPassword,
  showModalInnerAlert,
  sendMagicLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(SigninContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/signin.container.js